import {
    ArticleEntity,
    ArticleSchema,
    BlogPostEntity,
    BlogPostSchema,
    CommentEntity,
    CommentSchema,
    ImageEntity,
    ImageSchema,
} from 'mk2/apps/blogs/schemas';
import { MessageSchema, PostEntity, PostSchema } from 'mk2/apps/forum/schemas';
import { Entity, UserEntity, UserSchema } from 'mk2/schemas';
import { schema } from 'normalizr';

export const complaintKey = (entity: string, id: number): string => `${entity}/${id}`;

export enum ComplaintTargetType {
    ForumMessage = 'forum-message',
    ForumThread = 'forum-thread',
    PhotoblogComment = 'photoblog-comment',
    PhotoblogImage = 'photoblog-image',
    PhotoblogPost = 'photoblog-post',
    BlogsArticle = 'blogs-article',
    BazaarProduct = 'bazaar-product',
}

export type ComplaintTargetEntity = BlogPostEntity | CommentEntity | ImageEntity | PostEntity | ArticleEntity;

interface UnionKey {
    schema: ComplaintTargetType;
}

export interface ComplaintEntity extends Entity {
    readonly user: UserEntity;
    readonly target: ComplaintTargetEntity & UnionKey;
    readonly comment: string;
    readonly createdAt: string;
    readonly deletedAt: string;
    readonly imageId?: number;
}

const complaintTargetSchemas = {
    [ComplaintTargetType.ForumMessage]: MessageSchema,
    [ComplaintTargetType.ForumThread]: PostSchema,
    [ComplaintTargetType.PhotoblogImage]: ImageSchema,
    [ComplaintTargetType.PhotoblogPost]: BlogPostSchema,
    [ComplaintTargetType.BlogsArticle]: ArticleSchema,
    [ComplaintTargetType.PhotoblogComment]: CommentSchema,
};

export function addComplaintTargetSchema(key: ComplaintTargetType, sch: schema.Entity) {
    complaintTargetSchemas[key] = sch;
    ComplaintTargetSchema.define(complaintTargetSchemas);
}

const ComplaintTargetSchema = new schema.Union(complaintTargetSchemas, 'target');

export const ComplaintSchema = new schema.Entity('complaints', {
    user: UserSchema,
    target: ComplaintTargetSchema,
});

export const CommentComplaintSchema = new schema.Entity('complaints', {
    user: UserSchema,
    target: CommentSchema,
});
